import { useNotification } from 'admin';
import { BaleAnalysisProvider, useBaleAnalysis } from 'features';
import { useState } from 'react';
import { Grid, Page, PhotoEvidenceList, PhotoFilePicker, Section } from 'ui';

import { ExternalEvidenceForm } from '../../components/ExternalEvidenceForm/ExternalEvidenceForm';

const ExternalEvidenceUpload = () => {
  const { bales, addBalePhoto, isBaleLoading } = useBaleAnalysis();
  const { open } = useNotification();
  const balePhotos = bales.map((bale) => ({
    src: URL.createObjectURL(bale.photo),
  }));

  const handleFileUpload = async (files: File[]): Promise<void> => {
    await Promise.all(files.map((file) => addBalePhoto({ photo: file })));
    open?.({
      message: 'Successfully uploaded evidence',
      type: 'success',
    });
  };

  return (
    <Section
      title="Upload Evidence"
      action={
        <PhotoFilePicker
          onSelectFiles={handleFileUpload}
          multiple={true}
          label="Upload evidence"
          accept="image/*;"
          loading={isBaleLoading}
        />
      }
    >
      {balePhotos.length ? <PhotoEvidenceList evidencePhotos={balePhotos} /> : 'No evidence uploaded'}
    </Section>
  );
};
export const ExternalEvidence = () => {
  const [evidenceId, setEvidenceId] = useState<string | undefined>(undefined);

  return (
    <Page>
      <Page.Title title="External Evidence" />

      <Page.Divider />

      <Grid container>
        <Grid item xs={12}>
          <Section title="Evidence metadata">
            <ExternalEvidenceForm
              onSubmitSuccess={(id) => {
                setEvidenceId(id);
              }}
            />
          </Section>
        </Grid>
        <Grid item xs={12}>
          {evidenceId ? (
            <BaleAnalysisProvider mode="external-evidence" parentId={evidenceId}>
              <ExternalEvidenceUpload />
            </BaleAnalysisProvider>
          ) : null}
        </Grid>
      </Grid>
    </Page>
  );
};
